import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
const benefits = [{
  icon: '📚',
  title: '6 Volumes · 60+ Séances',
  desc: 'Votre année complète de Yoga déjà planifiée — ouvrez, lisez et enseignez.',
  bullets: ['Vinyasa Flow, Hatha Fondamental, Yoga Dôux, Power Yoga, Yin & Mobilité', 'Progressions réelles de débutant à avancé', 'Cueings prêts à dire mot pour mot'],
  value: '97€'
}, {
  icon: '🩺',
  title: 'Protocoles Anatomiques',
  desc: 'Travaillez en toute sécurité face aux pathologies communes.',
  bullets: ['Hernies et problèmes lombaires', 'Scoliose, hypercyphose et cervicales', "Douleurs d'épaules et de genoux"],
  value: '57€'
}, {
  icon: '🤰',
  title: 'Populations Spéciales',
  desc: 'Ajoutez de nouveaux élèves avec des adaptations professionnelles prêtes.',
  bullets: ['Yoga Prénatal trimestre par trimestre', 'Seniors avec ostéoporose', 'Adaptations sûres et graduelles'],
  value: '47€'
}, {
  icon: '🌊',
  title: 'Planification "Flow"',
  desc: 'Cours sans pauses gênantes, avec rythme et transitions de haut niveau.',
  bullets: ['Modèles de transitions fluides', 'Structure énergétique par blocs', "Clôture avec sensation d'accomplissement"],
  value: '49€'
}];
const headlineStats = [{
  num: '350+',
  label: 'Pages'
}, {
  num: '6',
  label: 'Volumes'
}, {
  num: '+12',
  label: 'Mois de cours'
}, {
  num: '100%',
  label: 'Éditable'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-1">
      {/* Soft background glow */}
      <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-2"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-3">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-4">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-5">
            🎁 Ce que vous recevez
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-6">
            Tout ce dont vous avez besoin,{' '}
            <span className="text-primary" data-id="element-7">en un seul endroit</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-8">
            4 piliers de contenu technique pour éliminer le stress hebdomadaire
            et élever la qualité de chaque cours que vous donnez.
          </p>
        </div>

        {/* Headline stats strip */}
        <div className="grid grid-cols-4 gap-2 sm:gap-4 mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-9">
          {headlineStats.map((s, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-xl py-3 sm:py-4 px-2 text-center" data-id="element-10">
              <p className="text-primary font-black text-lg sm:text-2xl leading-none mb-1" data-id="element-11">
                {s.num}
              </p>
              <p className="text-text-sec text-[10px] sm:text-xs font-medium uppercase tracking-wider" data-id="element-12">
                {s.label}
              </p>
            </div>)}
        </div>

        {/* Benefit cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6" data-id="element-13">
          {benefits.map((benefit, i) => <article key={i} className="bg-bg-alt rounded-3xl border border-border-light p-6 sm:p-8 flex flex-col relative overflow-hidden hover:-translate-y-1 hover:border-primary/40 hover:shadow-[0_18px_40px_-15px_rgba(139,111,191,0.3)] transition-all duration-300 group shadow-[0_4px_20px_-10px_rgba(90,70,120,0.12)]" data-id="element-14">
              {/* "Incluido" badge */}
              <div className="absolute top-5 right-5 sm:top-6 sm:right-6 flex items-center gap-1.5 bg-cta-green/10 text-cta-green border border-cta-green/25 px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-15">
                <Check className="w-3 h-3" data-id="element-16" />
                Inclus
              </div>

              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/25 flex items-center justify-center text-3xl mb-5 shadow-inner" data-id="element-17">
                {benefit.icon}
              </div>

              {/* Title + value */}
              <div className="mb-2" data-id="element-18">
                <h3 className="text-xl sm:text-2xl font-black text-text-main leading-tight" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-20">
                  Valeur :{' '}
                  <span className="text-text-main font-bold line-through" data-id="element-21">
                    {benefit.value}
                  </span>{' '}
                  · Aujourd'hui :{' '}
                  <span className="text-cta-green font-bold" data-id="element-22">
                    Gratuit avec le Kit
                  </span>
                </p>
              </div>

              {/* Description */}
              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-5" data-id="element-23">
                {benefit.desc}
              </p>

              {/* Sub-bullets — concrete benefits */}
              <ul className="space-y-2 mt-auto" data-id="element-24">
                {benefit.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5 text-text-main text-sm sm:text-[15px] font-medium" data-id="element-25">
                    <Check className="w-4 h-4 text-cta-green flex-shrink-0 mt-0.5" data-id="element-26" />
                    <span data-id="element-27">{b}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>

        {/* Total value reinforcement + CTA */}
      </div>
    </section>;
}